module.exports = __webpack_public_path__ + "static/media/salad-white.b459d1c6.svg";